import { combineReducers } from 'redux'
import stagedRecord from './stagedRecord'
import records from './records'

export default combineReducers({ stagedRecord, records })
